import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { enumUtil } from "../../utils/Enum";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import NotificationHandler from "../../utils/NotificationHandler";
import { useDispatch, useSelector } from "react-redux";
import { logIn } from "../../actions/LoginAction";
import Cookies from "js-cookie";
const TwoFactorOTP = () => {
    const API_URL = enumUtil.controller.Login;
    const location = useLocation();
    const navigate = useNavigate();
    const fullResponse = location.state?.fullResponse;
    const year = new Date().getFullYear();

    const [isLoading, setIsLoading] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const otpRefs = useRef([]);
    const dispatch = useDispatch();
    const maskEmail = (email) => {
        if (!email) return "";
        const [localPart, domainPart] = email.split("@");
        const localStart = localPart.slice(0, 2);
        const localMasked = localStart + "*".repeat(Math.max(localPart.length - 2, 0));
        return `${localMasked}@${domainPart}`;
    };

    const handleOTPChange = (value, index) => {
        // Allow only digits
        if (!/^\d*$/.test(value)) return;

        const digit = value.slice(-1); // Take last character entered
        const newOTP = [...otp];
        newOTP[index] = digit;
        setOtp(newOTP);

        // Auto focus next input
        if (digit && index < 5) {
            otpRefs.current[index + 1]?.focus();
        }
        if (newOTP.every((item) => item !== "")) {
            handleSubmit(newOTP.join(""));
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();

            const newOTP = [...otp];

            // If current input has a value, clear it first
            if (otp[index]) {
                newOTP[index] = "";
                setOtp(newOTP);

                // Move to previous input
                if (index > 0) {
                    otpRefs.current[index - 1]?.focus();
                }

                return;
            }

            // If current input is already empty,
            // move to previous input and clear it
            if (index > 0) {
                newOTP[index - 1] = "";
                setOtp(newOTP);
                otpRefs.current[index - 1]?.focus();
            }
        }

        if (e.key === "ArrowLeft" && index > 0) {
            e.preventDefault();
            otpRefs.current[index - 1]?.focus();
        }

        if (e.key === "ArrowRight" && index < 5) {
            e.preventDefault();
            otpRefs.current[index + 1]?.focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").trim();

        if (!/^\d+$/.test(pasteData)) return;

        const pasteArray = pasteData.split("").slice(0, 6);
        const newOTP = [...otp];

        pasteArray.forEach((digit, idx) => {
            newOTP[idx] = digit;
        });

        setOtp(newOTP);

        // Focus appropriate input post-paste
        if (!newOTP.every(item => item !== "")) {
            const targetIndex = Math.min(pasteArray.length, 5);
            otpRefs.current[targetIndex]?.focus();
        }

        if (newOTP.every((item) => item !== "")) {
            handleSubmit(newOTP.join(""));
        }
    };

    const handleSubmit = (otpValue) => {
        if (isLoading) return;

        const finalOTP = otpValue || otp.join("");
        if (finalOTP.length < 6) {
            NotificationHandler("Please enter a complete 6-digit OTP", enumUtil.enumtoaster.error);
            return;
        }

        setIsLoading(true);
        ServerRequestProtected(API_URL + "/Confirm2FAOTP", "post", {
            email: fullResponse?.email,
            OTP: finalOTP,
        })
            .then(() => {
                setIsLoading(false);
                NotificationHandler("Login Successful", enumUtil.enumtoaster.success);
                dispatch(logIn({ token: fullResponse?.token }))
                fullResponse?.token && Cookies.set('cookedToken', fullResponse?.token, { expires: 1 });
                navigate("../pms", { replace: true });
            })
            .catch((error) => {
                setIsLoading(false);
                const errorMsg = error.response?.data?.message || error.response?.data || "Verification failed";
                NotificationHandler(errorMsg, enumUtil.enumtoaster.error);
            });
    };

    const handleResendOTP = () => {
        if (isLoading) return;

        setIsLoading(true);
        ServerRequestProtected(API_URL + "/Send2FAOTP", "post", {
            email: fullResponse?.email,
        })
            .then(() => {
                setIsLoading(false);
                setOtp(["", "", "", "", "", ""])
                NotificationHandler("OTP Successfully Sent", enumUtil.enumtoaster.success);
            })
            .catch((error) => {
                setIsLoading(false);
                const errorMsg = error.response?.data?.message || error.response?.data || "Failed to resend OTP";
                NotificationHandler(errorMsg, enumUtil.enumtoaster.error);
            });
    };

    useEffect(() => {
        if (otp.every((item) => item === "")) {
            otpRefs.current[0]?.focus();
        }
    }, [otp]);

        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <div className="ar_login-screen">
            <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                <div className="login-content">
                    <div className="d-flex flex-column align-items-center mb-10 text-center">
                        <p className="fs-20 heading lh-normal">Two-Factor Authentication</p>
                        <p className="text fs-11 color-muted lh-normal">
                            An email with OTP has been sent to <br /> {maskEmail(fullResponse?.email)}
                        </p>
                    </div>
                    <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">
                        <div className="mt-2">
                            <div className="d-flex align-items-center gap-12 justify-content-center py-1 mb-4 input-for-authantication">
                                {otp.map((digit, index) => (
                                    <div className="input w-41px" key={index}>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={1}
                                            className="form-control fs-17 text-black text-center"
                                            value={digit}
                                            onPaste={handlePaste}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            onChange={(e) => handleOTPChange(e.target.value, index)}
                                            ref={(el) => (otpRefs.current[index] = el)}
                                            disabled={isLoading}
                                            autoComplete="off"
                                        />
                                    </div>
                                ))}
                            </div>
                            <p className="text fs-14 text-center">
                                Didn’t receive a code or need a new one?{" "}
                                <span
                                    className={`heading ar-dark-color cursor-pointer fs-14 ${isLoading ? "pe-none opacity-50" : ""}`}
                                    onClick={handleResendOTP}
                                >
                                    Resend
                                </span>
                            </p>
                        </div>
                        <div className="position-relative login-btn-loader">
                            <button
                                type="button"
                                className="btn rounded btn-orange heading w-100"
                                onClick={handleSubmit}
                                disabled={isLoading}
                            >
                                {isLoading ? "" : "Continue"}
                            </button>

                            {isLoading && (
                                <div className="last_loader ar-small-loader">
                                    <div className="circle circle1"></div>
                                    <div className="circle circle2"></div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <p className="text fs-12 color-95">©{year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TwoFactorOTP;